


export const ROMCOM_TROPES = [
  { id: 1, name: 'Fake Dating', icon: '🤝' },
  { id: 2, name: 'Enemies to Lovers', icon: '⚔️' },
  { id: 3, name: 'Friends to Lovers', icon: '❤️' },
  { id: 4, name: 'Second Chance', icon: '🔄' },
  { id: 5, name: 'Love Triangle', icon: '🔺' },
  { id: 6, name: 'Makeover', icon: '💄' },
  { id: 7, name: 'Forced Proximity', icon: '🏠' },
  { id: 8, name: 'Opposites Attract', icon: '🧲' },
  { id: 9, name: 'Holiday Romance', icon: '🎄' },
  { id: 10, name: 'Workplace Romance', icon: '💼' },
  { id: 11, name: 'Small Town', icon: '🏡' },
  { id: 12, name: 'Royal Romance', icon: '👑' },
];

export const MOOD_CATEGORIES = [
  { id: 1, name: 'Feel-Good', icon: '😊', color: 'bg-green-100 text-green-800' },
  { id: 2, name: 'Cozy', icon: '☕', color: 'bg-orange-100 text-orange-800' },
  { id: 3, name: 'Tearjerker', icon: '😢', color: 'bg-blue-100 text-blue-800' },
  { id: 4, name: 'Comfort', icon: '🛋️', color: 'bg-purple-100 text-purple-800' },
  { id: 5, name: 'Classic', icon: '🎞️', color: 'bg-yellow-100 text-yellow-800' },
  { id: 6, name: 'Funny', icon: '😂', color: 'bg-pink-100 text-pink-800' },
  { id: 7, name: 'Emotional', icon: '💖', color: 'bg-red-100 text-red-800' },
];

export const DECADES = [
  { id: 1, name: '80s Romcoms', years: '1980-1989', icon: '🕺', count: 15 },
  { id: 2, name: '90s Classics', years: '1990-1999', icon: '📼', count: 42 },
  { id: 3, name: '2000s Gold', years: '2000-2009', icon: '📱', count: 38 },
  { id: 4, name: '2010s Modern', years: '2010-2019', icon: '📱', count: 45 },
  { id: 5, name: '2020s New', years: '2020-Present', icon: '🎬', count: 22 },
];



export const SEASONAL_COLLECTIONS = [
  {
    id: 1,
    season: 'winter' as const,
    title: 'Winter Warmers',
    description: 'Cozy up with these winter romance classics',
    color: 'bg-season-winter',
    icon: '❄️',
    count: 28,
  },
  {
    id: 2,
    season: 'spring' as const,
    title: 'Spring Blossoms',
    description: 'Fresh starts and new beginnings',
    color: 'bg-season-spring',
    icon: '🌸',
    count: 32,
  },
  {
    id: 3,
    season: 'summer' as const,
    title: 'Summer Lovin',
    description: 'Sunny days and warm nights',
    color: 'bg-season-summer',
    icon: '☀️',
    count: 45,
  },
  {
    id: 4,
    season: 'autumn' as const,
    title: 'Autumn Romance',
    description: 'Fall in love all over again',
    color: 'bg-season-autumn',
    icon: '🍂',
    count: 31,
  },
];

export const HOLIDAY_COLLECTIONS = [
  {
    id: 1,
    holiday: 'christmas' as const,
    title: 'Christmas Romcoms',
    description: 'Feel-good holiday movies to get you in the spirit',
    color: 'bg-christmas',
    icon: '🎄',
    count: 24,
  },
  {
    id: 2,
    holiday: 'valentine' as const,
    title: 'Valentine Specials',
    description: 'All about love and romance',
    color: 'bg-valentine',
    icon: '💝',
    count: 18,
  },
  {
    id: 3,
    holiday: 'new-year' as const,
    title: 'New Year',
    description: 'Fresh starts and midnight kisses',
    color: 'bg-blue-500',
    icon: '🎆',
    count: 12,
  },
];

// export const SORT_OPTIONS = [
//   { id: 1, name: 'Most Popular', value: 'popularity_desc' },
//   { id: 2, name: 'Highest Rated', value: 'rating_desc' },
//   { id: 3, name: 'Newest', value: 'release_year_desc' },
//   { id: 4, name: 'Oldest', value: 'release_year_asc' },
//   { id: 5, name: 'A-Z', value: 'title_asc' },
//   { id: 6, name: 'Z-A', value: 'title_desc' },
// ];